import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M14.165 9.167v-2.5a4.167 4.167 0 0 0-8.333 0v2.5m1.5 8.333h5.333c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.093-1.092c.272-.535.272-1.235.272-2.635v-.333c0-1.4 0-2.1-.272-2.635A2.5 2.5 0 0 0 15.3 9.439c-.534-.272-1.235-.272-2.635-.272H7.332c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.092 1.093c-.273.534-.273 1.235-.273 2.635v.333c0 1.4 0 2.1.273 2.635a2.5 2.5 0 0 0 1.092 1.092c.535.273 1.235.273 2.635.273"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }